var _g, _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareWithDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_392_80822)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "#3E74B5",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 39,
    fill: "#2B67AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0864 51.2244C39.924 51.2244 35.739 47.0994 35.739 42.0112V34.6407C35.739 33.6232 36.5761 32.7981 37.6085 32.7981H39.478C40.5103 32.7981 41.3474 31.9729 41.3474 30.9554C41.3474 29.9379 40.5103 29.1128 39.478 29.1128H37.6085C34.5111 29.1128 32 31.5878 32 34.6407V42.0112C32.0049 46.2367 34.1155 50.1906 37.6459 52.5879C41.0225 55.5221 43.0352 59.6894 43.2169 64.1228C43.2169 71.2464 49.0759 77.0212 56.3033 77.0212C63.5308 77.0212 69.3898 71.2464 69.3898 64.1228V62.0222C73.3886 61.0047 75.7931 56.9844 74.7608 53.043C73.7281 49.1017 69.6496 46.7317 65.6508 47.7492C61.6519 48.767 59.2474 52.7869 60.2797 56.7283C60.9599 59.3246 63.0167 61.3518 65.6508 62.0222V64.1228C65.6508 69.211 61.4657 73.3359 56.3033 73.3359C51.1409 73.3359 46.9559 69.211 46.9559 64.1228C47.147 59.6839 49.1739 55.5155 52.5644 52.5879C56.0805 50.1822 58.1766 46.2301 58.1728 42.0112V34.6407C58.1728 31.5878 55.6617 29.1128 52.5644 29.1128H50.6949C49.6625 29.1128 48.8254 29.9379 48.8254 30.9554C48.8254 31.9729 49.6625 32.7981 50.6949 32.7981H52.5644C53.5967 32.7981 54.4338 33.6232 54.4338 34.6407V42.0112C54.4338 47.0994 50.2488 51.2244 45.0864 51.2244ZM67.5203 58.5949C65.4552 58.5949 63.7813 56.945 63.7813 54.9096C63.7813 52.8743 65.4552 51.2244 67.5203 51.2244C69.5853 51.2244 71.2592 52.8743 71.2592 54.9096C71.2592 56.945 69.5853 58.5949 67.5203 58.5949Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_392_80822",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_392_80822"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_392_80822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_392_80822",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_392_80822"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWithDoctor);
export default __webpack_public_path__ + "static/media/ShareWithDoctor.0c235d2ab5f206fc7e75a6f835fea892.svg";
export { ForwardRef as ReactComponent };